import { Radio, styled } from '@mui/material';

export const RadioButton = styled(Radio)(({ theme }) => ({
  color: theme.palette.mapBlue[300],
  '&.Mui-checked': {
    color: theme.palette.common.white,
  },
  '& .MuiSvgIcon-root': {
    fill: theme.palette.mapBlue[300],
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    fill: theme.palette.common.white,
  },
}));
